<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg width="100%" height="100%" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <g transform="matrix(0.9375,0,0,0.9375,16,16)">
        <g transform="matrix(23.7697,0,0,23.7697,-5.46656,6.4183)">
            <path d="M0.23,20.77L14.23,15.77L5.23,6.77L0.23,20.77ZM10.58,14.95L3.53,17.47L6.05,10.42L10.58,14.95Z" style="fill-rule:nonzero;"/>
        </g>
        <g transform="matrix(23.7697,0,0,23.7697,-5.46656,6.4183)">
            <path d="M12.76,11.3L18.35,5.71C18.84,5.22 19.63,5.22 20.12,5.71L20.71,6.3L21.77,5.24L21.18,4.65C20.11,3.58 18.36,3.58 17.29,4.65L11.7,10.24L12.76,11.3Z" style="fill-rule:nonzero;"/>
        </g>
        <g transform="matrix(23.7697,0,0,23.7697,-5.46656,6.4183)">
            <path d="M8.29,5.65L7.7,6.24L8.76,7.3L9.35,6.71C10.42,5.64 10.42,3.89 9.35,2.82L8.76,2.23L7.7,3.3L8.29,3.89C8.77,4.37 8.77,5.17 8.29,5.65Z" style="fill-rule:nonzero;"/>
        </g>
        <g transform="matrix(23.7697,0,0,23.7697,-5.46656,6.4183)">
            <path d="M15.29,10.65L13.7,12.24L14.76,13.3L16.35,11.71C16.84,11.22 17.63,11.22 18.12,11.71L19.73,13.32L20.79,12.26L19.18,10.65C18.1,9.58 16.36,9.58 15.29,10.65Z" style="fill-rule:nonzero;"/>
        </g>
        <g transform="matrix(23.7697,0,0,23.7697,-5.46656,6.4183)">
            <path d="M13.29,4.65L9.7,8.24L10.76,9.3L14.35,5.71C15.42,4.64 15.42,2.89 14.35,1.82L12.76,0.23L11.7,1.29L13.29,2.88C13.77,3.37 13.77,4.17 13.29,4.65Z" style="fill-rule:nonzero;"/>
        </g>
    </g>
</svg>
